import useViewerStore from "@/stores/useViewerStore";
import { useTranslation } from "react-i18next";
import PropertyWindowHeader from "../PropertyWindow/components/PropertyWindowHeader";
import { Separator } from "../ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import Groupview from "./Groupview";
import Treeview from "./Treeview";

const ObjectViews = () => {
    const { toggleModelBrowser } = useViewerStore();
    const { t } = useTranslation();

    return (
        <>
            <PropertyWindowHeader title={t("objectViews.modelBrowserTitle")} onClose={toggleModelBrowser} />
            
            <Tabs defaultValue="containment" className="flex-1 h-full min-w-[400px] select-none">
                <TabsList className="grid grid-cols-2">
                    <TabsTrigger value="containment">{t("objectViews.containmentHierarchy")}</TabsTrigger>
                    <TabsTrigger value="component">{t("objectViews.componentHierarchy")}</TabsTrigger>
                </TabsList>
                <Separator />
                <TabsContent value="containment" className="h-full">
                    <Treeview />
                </TabsContent>
                <TabsContent value="component" className="h-full">
                    <Groupview />
                </TabsContent>
            </Tabs>
        </>
    );
};

export default ObjectViews;
